import { createAction, props } from '@ngrx/store';
import {FirmaZeitItem} from '@src/app/pages/Mitarbeiterverwaltung/firmaZeit.model';

export const addFirmaZeitStart = createAction('MITARBEITERVERWALTUNG::ADD_FIRMAZEIT_START');
export const addFirmaZeitSucceeded = createAction('MITARBEITERVERWALTUNG::ADD_FIRMAZEIT_SUCCEEDED', props<{ item: number }>());
export const addFirmaZeitFailed = createAction('MITARBEITERVERWALTUNG::ADD_FIRMAZEIT_FAILED', props<{ error: Error }>());
